import styled from '@emotion/styled';

import { mq } from '@/utility/mediaQuery';
import { defaultTheme } from '@/utility/theme';

export const Container = styled.div(() =>
  mq({
    width: '100%',
    margin: '0 auto',
  }),
);

export const AlertWrapper = styled.div(() =>
  mq({
    width: '100%',
    maxWidth: ['528px', '528px', '528px', '950px'],
    padding: [
      `0 ${defaultTheme.spacing.l}`,
      `0 ${defaultTheme.spacing.l}`,
      `0 ${defaultTheme.spacing.l}`,
      0,
    ],
    margin: [
      `${defaultTheme.spacing.l} auto`,
      `${defaultTheme.spacing.l} auto`,
      `${defaultTheme.spacing.xxl} auto`,
      `${defaultTheme.spacing.xxl} auto`,
    ],
  }),
);

export const ContentsWrapper = styled.div(() =>
  mq({
    display: 'flex',
    flexDirection: ['column', 'column', 'column', 'column', 'row'],
    justifyContent: 'center',
    gap: '40px',
    alignItems: 'flex-start',
    width: ['100%', '100%', '100%', '100%', 'calc(100% - 64px)'],
    margin: '0 auto',
  }),
);

export const PrimaryBox = styled.div(() =>
  mq({
    width: '100%',
    maxWidth: ['528px', '528px', '760px', '950px'],
    padding: [
      `0 ${defaultTheme.spacing.l}`,
      `0 ${defaultTheme.spacing.l}`,
      `0 ${defaultTheme.spacing.l}`,
      `0 ${defaultTheme.spacing.l}`,
      0,
    ],
    margin: ['0 auto', '0 auto', '0 auto', '0 auto', '0'],
  }),
);

export const RaceTypeSelectorWrapper = styled.div(() =>
  mq({
    width: 'auto',
    margin: '0 auto',
  }),
);

export const SideBox = styled.aside(() =>
  mq({
    width: ['100%', '100%', '100%', '100%', '240px'],
  }),
);

export const TopBannerWrapper = styled.div(() =>
  mq({
    padding: [
      0,
      `0 ${defaultTheme.spacing.l}`,
      `0 ${defaultTheme.spacing.l}`,
      `0 ${defaultTheme.spacing.l}`,
      0,
    ],
  }),
);

export const BannerWrapper = styled(TopBannerWrapper)(() =>
  mq({
    margin: [`40px 0 0`, `40px 0 0`, '64px auto 0', '64px auto 0'],
  }),
);

export const SlideBannerList = styled.ul(() =>
  mq({
    display: ['flex', 'flex', 'grid'],
    gridTemplateColumns: [
      'none',
      'none',
      'repeat(auto-fit, 240px)',
      'repeat(4, 240px)',
      'repeat(1, 240px)',
    ],
    gap: defaultTheme.spacing.s,
    justifyContent: ['flex-start', 'flex-start', 'center'],
    width: 'calc(100vw - 32px)',
    minWidth: ['100%', 'unset'],
    maxWidth: ['496px', '496px', '496px', '100%'],
    margin: '0 auto',
    padding: [`0 ${defaultTheme.spacing.l}`, 0],
    overflow: 'auto',
    overflowY: 'hidden',
    '& > li, a': {
      width: ['192px', '192px', '240px', '240px'],
      height: ['60px', '60px', '75px', '75px'],
    },
  }),
);

export const MiddleBannerList = styled(SlideBannerList)(() =>
  mq({
    gridTemplateColumns: [
      'none',
      'none',
      'repeat(auto-fit, 240px)',
      'repeat(4, 240px)',
    ],
    flexDirection: 'row !important',
  }),
);

export const BottomBannerList = styled.ul(() =>
  mq({
    display: 'grid',
    gridTemplateColumns: [
      `repeat(auto-fit, 192px)`,
      `repeat(auto-fit, 192px)`,
      `repeat(auto-fit, 240px)`,
      'repeat(auto-fit, 240px)',
    ],
    gridTemplateRows: ['60px', '60px', '75px', '75px'],
    gridGap: defaultTheme.spacing.s,
    justifyContent: 'center',
    margin: `${defaultTheme.spacing.xxl} 0 40px`,
    '& > li, a': {
      width: ['192px', '192px', '240px', '240px'],
      height: ['60px', '60px', '75px', '75px'],
    },
  }),
);

export const InformationBox = styled.div(() =>
  mq({
    backgroundColor: [
      'transparent',
      'transparent',
      defaultTheme.background.white,
      defaultTheme.background.white,
    ],
    padding: [0, 0, '32px', '32px'],
    margin: ['40px 0 0', '40px 0 0', '40px 0 0', '64px auto 0'],
    width: '100%',
  }),
);

export const NewsWrapper = styled.div(() =>
  mq({
    display: 'grid',
    gridTemplateColumns: ['1fr', '1fr', '1fr', 'repeat(auto-fit, 608px)'],
    gridGap: [defaultTheme.spacing.s, defaultTheme.spacing.s, '64px', '64px'],
    justifyContent: 'center',
    width: 'auto',
    margin: [0, 0, '0 auto', '0 auto'],
  }),
);
